import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import './Entourage.css';

const CATEGORIES = [
  { key: 'famille', label: 'Sa famille', emoji: 'famille', color: '#8b1a2a' },
  { key: 'amis', label: 'Ses amis', emoji: 'amis', color: '#b05070' },
  { key: 'pro', label: 'Entourage pro', emoji: 'pro', color: '#c47840' },
  { key: 'autres', label: 'Autres', emoji: 'autres', color: '#c49090' }
];

export default function Entourage() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [texts, setTexts] = useState({});
  const [activeCategory, setActiveCategory] = useState('');
  const [selected, setSelected] = useState(null);

  const fetchItems = async (cat) => {
    const url = cat ? '/api/entourage?category=' + cat : '/api/entourage';
    const res = await fetch(url);
    const data = await res.json();
    setItems(data);
  };

  const fetchTexts = async () => {
    const res = await fetch('/api/entourage/texts');
    const data = await res.json();
    const map = {};
    data.forEach(t => { map[t.category] = t; });
    setTexts(map);
  };

  useEffect(() => { fetchItems(activeCategory); fetchTexts(); }, [activeCategory]);

  const visibleCategories = activeCategory
    ? CATEGORIES.filter(c => c.key === activeCategory)
    : CATEGORIES;

  return (
    <div className="ent-page">
      <div className="ent-eyebrow">Michael — Son entourage</div>
      <h1 className="ent-title">Son entourage, <em>ceux qui l'ont connu</em></h1>
      <p className="ent-intro">Les proches, amis, collaborateurs et famille qui ont partage la vie de Michael Jackson.</p>

      <div className="ent-tabs">
        <button className={'ent-tab' + (activeCategory === '' ? ' active' : '')} onClick={() => setActiveCategory('')}>Tout</button>
        {CATEGORIES.map(c => (
          <button key={c.key} className={'ent-tab' + (activeCategory === c.key ? ' active' : '')} onClick={() => setActiveCategory(c.key)}>{c.label}</button>
        ))}
      </div>

      {visibleCategories.map(cat => {
        const catItems = items.filter(i => i.category === cat.key);
        const t = texts[cat.key];
        if (!activeCategory && catItems.length === 0 && !t) return null;
        return (
          <div key={cat.key} className="ent-section">
            {(t && (t.title || t.text)) && (
              <div className="ent-section-header" style={{ borderLeftColor: cat.color }}>
                <div className="ent-section-label" style={{ color: cat.color }}>{cat.label}</div>
                {t.title && <div className="ent-section-title">{t.title}</div>}
                {t.text && <div className="ent-section-text">{t.text}</div>}
              </div>
            )}
            {catItems.length > 0 ? (
              <div className="ent-masonry">
                {catItems.map(item => (
                  <div key={item._id} className="ent-card" onClick={() => setSelected(item)}>
                    <div className="ent-card-img">
                      <img src={item.imageUrl} alt={item.name} loading="lazy" />
                    </div>
                    <div className="ent-card-body">
                      <div className="ent-card-name">{item.name}</div>
                      {item.description && <div className="ent-card-desc">{item.description}</div>}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="ent-empty">Aucune personne dans cette categorie pour l'instant.</p>
            )}
          </div>
        );
      })}

      {selected && (
        <div className="ent-lightbox" onClick={() => setSelected(null)}>
          <div className="ent-lightbox-inner" onClick={e => e.stopPropagation()}>
            <button className="ent-lightbox-close" onClick={() => setSelected(null)}>x</button>
            <img src={selected.imageUrl} alt={selected.name} />
            <h2>{selected.name}</h2>
            {selected.description && <p>{selected.description}</p>}
          </div>
        </div>
      )}
    </div>
  );
}
